import { useCallback, useRef } from 'react';

// How far below the viewport the end of a dish grid can be before the next page loads, about a screen ahead, so diners
// rarely reach the loading skeleton
export const LOAD_MORE_THRESHOLD = 1000;

// Requests each page once. The infinite scroller re-checks its position after every render, which would otherwise
// request a page again while it's still loading. A page that fails to load can be requested again.
export const useLoadMoreOnce = () => {
  const requestedPage = useRef<string | null>(null);

  return useCallback((page: string, loadMore: () => Promise<unknown>) => {
    if (requestedPage.current === page) return;

    requestedPage.current = page;
    loadMore().catch(() => {
      requestedPage.current = null;
    });
  }, []);
};
